module.exports = __webpack_public_path__ + "img/logo-rossignol.a5897fa1.svg";